(function ($) {
    $(function () {

        function load_more_blogs(ctax, cterm, reload) {
            axios.post(localize.ajaxurl, $.param(
                {
                    action: 'load_more_blogs',
                    offset: (!reload) ? $('.js-blog-card').length : 0,
                    is_tax: $('.js-blog-selector').attr('data-is-taxonomy'),
                    current_taxonomy: ctax,
                    current_term: cterm,
                }
            )
            ).then(function (response) {

                if (reload) {
                    $('.js-blogs-wrapper').empty();
                    $('.js-load-more').text('+ More news').removeClass('disabled');
                }

                if (response.data.have_posts == 1) {
                    var $newElems = $(response.data.html.replace(/(\r\n|\n|\r)/gm, ''));

                    $newElems.hide().appendTo('.js-blogs-wrapper').fadeIn(500);

                } else {
                    $('.js-load-more').addClass('disabled');
                }


                $('.js-load-more').fadeIn();

            }).catch(function (error) {
                console.log(error);
            });
        };

        $('.js-load-more').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) {
                return false;
            }

            $(this).fadeOut('400', function (e) {

                load_more_blogs($('.js-blog-selector').attr('data-taxonomy'), $('.js-blog-selector').attr('data-term'), false);
            });

        });





    });
})(jQuery);
